<template>
  <v-app>
    <v-content>
      <v-container fill-height class="primary" style="position: relative;">
        <v-layout align-center justify-center>
          <v-flex class="login-form text-xs-center">
            <div class="display-1 mb-3 white--text">Hawk</div>
            <v-card light>
              <v-card-text>
                <v-alert
                  :value="error"
                  type="warning"
                  dismissible
                  style="margin-bottom: 1rem;"
                >
                  Login fehlgeschlagen.
                </v-alert>
                <v-form @submit="login">
                  <v-text-field
                    v-model.trim="email"
                    :error-messages="emailErrors"
                    light
                    prependIcon="email"
                    label="Email"
                    type="email"
                  />
                  <v-text-field
                    v-model.trim="password"
                    :error-messages="passwordErrors"
                    light
                    prependIcon="lock"
                    label="Password"
                    type="password"
                  />
                  <v-btn block="block" type="submit">Login</v-btn>
                </v-form>
              </v-card-text>
            </v-card>
            <div
              style="display: flex; justify-content: space-between; align-items: flex-end;"
            >
              <p class="mt-2 white--text">Bentomax GmbH</p>
              <p class="white--text">{{ api }}</p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
import { config } from '../config'
export default {
  name: 'Login',
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    password: { required, minLength: minLength(6) },
  },
  data() {
    return {
      email: '',
      password: '',
      error: false,
      api: new URL(config.API).host,
    }
  },
  computed: {
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      !this.$v.email.email && errors.push('Bitte überprüfe deine Emailadresse')
      !this.$v.email.required &&
        errors.push('Bitte gebe deine Emailadresse ein')
      return errors
    },
    passwordErrors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.minLength &&
        errors.push('Dein Passowort muss mindestens 6 Zeichen sein')
      !this.$v.password.required &&
        errors.push('Bitte gebe deinen Passwort ein')
      return errors
    },
  },
  methods: {
    login(e) {
      e.preventDefault()
      this.$v.$touch()
      if (!this.$v.email.$error && !this.$v.password.$error) {
        const { email, password } = this
        this.$store
          .dispatch('login', { email, password })
          .then(() => {
            this.$router.push('/')
          })
          .catch(err => {
            this.error = !err.ok
          })
      }
    },
  },
}
</script>

<style>
.bg-green {
  background-color: #28b414;
}
</style>
